import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import BrandLogo from './BrandLogo';
import { brand } from '../../theme';

/** Layout das telas públicas (login, redefinição de senha). */
export default function AuthLayout({ title, subtitle, children, footer }) {
    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', bgcolor: 'background.default' }}>
            <Box
                sx={{
                    display: { xs: 'none', md: 'flex' },
                    width: '42%',
                    maxWidth: 560,
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    p: 5,
                    bgcolor: brand.ink,
                    color: '#FFFFFF',
                    borderRight: `1px solid ${brand.inkBorder}`,
                }}
            >
                <BrandLogo tone="dark" size={32} />
                <Box>
                    <Box sx={{ width: 32, height: 3, bgcolor: brand.green, borderRadius: 2, mb: 3 }} />
                    <Typography sx={{ fontSize: '1.75rem', fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1.25, maxWidth: 380 }}>
                        Painel administrativo da contabilidade.
                    </Typography>
                    <Typography sx={{ mt: 1.5, color: 'rgba(255,255,255,0.6)', maxWidth: 380, fontSize: '0.875rem' }}>
                        Gestão de clientes, obrigações fiscais, emissão de notas e documentos em um só lugar.
                    </Typography>
                </Box>
                <Typography sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.75rem' }}>
                    © {new Date().getFullYear()} Contblack. Acesso restrito à equipe.
                </Typography>
            </Box>

            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: { xs: 2, sm: 4 } }}>
                <Box sx={{ width: '100%', maxWidth: 400 }}>
                    <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'center', mb: 4 }}>
                        <BrandLogo tone="light" size={30} />
                    </Box>
                    <Paper variant="outlined" sx={{ p: { xs: 3, sm: 4 }, borderRadius: 3 }}>
                        <Typography variant="h3" component="h1">
                            {title}
                        </Typography>
                        {subtitle && (
                            <Typography variant="body1" color="text.secondary" sx={{ mt: 0.75, mb: 3 }}>
                                {subtitle}
                            </Typography>
                        )}
                        {children}
                    </Paper>
                    {footer && <Box sx={{ mt: 2, textAlign: 'center' }}>{footer}</Box>}
                </Box>
            </Box>
        </Box>
    );
}
